// extracted by mini-css-extract-plugin
export var avatar = "_l3-3";
export var avatarContainer = "_l3-2";
export var avatarSpacer = "_l3-5";
export var avatarSpacerContainer = "_l3-4";
export var avatarStackContainer = "_l3-1";
export var bubble = "_l3-0";
export var remainderBubble = "_l3-6";